<template>
  <modal :value="open" content-class="width-min-content" persistent>
    <v-card class="pa-5 width-min-content">
      <div class="rtsm-header modal-title mb-5">Configure Tags</div>
      <review-tags-settings-controller
        v-if="open"
        :review="review"
        is-modal
      />
      <div class="rtsm-actions-area mt-5">
        <action-button @click="$emit('close')">Close</action-button>
      </div>
    </v-card>
  </modal>
</template>

<script>
import { Review } from '@/models';
import ReviewTagsSettingsController from '@/components/ReviewSettingsPage/ReviewTagsSettingsController.vue';
import Modal from '@/components/Common/Modal.vue';
import ActionButton from '@/components/Common/ActionButton';

export default {
  name: 'ReferenceTagSettingsModal',
  components: {
    ReviewTagsSettingsController,
    Modal,
    ActionButton,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    review: {
      type: Review,
      default: () => null,
    },
  },
  emits: ['close'],
};
</script>

<style lang="scss" scoped>
.rtsm-actions-area {
  display: grid;
  justify-content: end;
}

.rtsm-header {
  display: grid;
  justify-content: center;
}

.modal-title {
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
}
</style>
